import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Images } from '../../config/images';
import './MarketHero.scss';
import { useSelector } from 'react-redux';
import WarningBar from '../WarningBar/WarningBar';
import SecondaryMarketIdentityUpload from '../SecondaryMarketIdentityUpload/SecondaryMarketIdentityUpload';
import { useNavigate } from 'react-router-dom';
import { KYC_NOT_VERIFIED_MESSAGE, checkOnboardingComplete } from '../../utils/constant';

const MarketHero = () => {
  const userData = useSelector((state) => state.userData);
  let navigate = useNavigate();
  const isKYCVerified = userData?.userData?.isKYCVerified;
  const isAMLApproved = userData?.userData?.isAMLApproved;
  const isDocRequiredForAml = userData?.userData?.isDocRequiredForAml;
  const counter = userData?.counter;
  const isOnboardingComplete = checkOnboardingComplete(userData?.userData, counter);
  const isProfileLoaded = userData?.isProfileLoaded;
  const [showIdentityModal, setShowIdentityModal] = useState(false);

  // Determine warning bar message and action based on priority:
  // 1. AML doc upload needed  2. Onboarding complete but KYC pending  3. Onboarding incomplete
  const getWarningBarProps = () => {
    if (!isAMLApproved && isDocRequiredForAml) {
      return {
        action: () => setShowIdentityModal(true),
        message: 'Upload required documents to complete your verification and continue investing with Realbricks!',
      };
    }
    if (!isKYCVerified && isOnboardingComplete) {
      return {
        action: undefined,
        message: KYC_NOT_VERIFIED_MESSAGE,
      };
    }
    return {
      action: () => navigate(`/sign-up/verification`),
      message: undefined,
    };
  };

  const isLoggedIn = !!localStorage.getItem('access_token');

  return (
    <>
      {isLoggedIn && isProfileLoaded && userData && Object.keys(userData?.userData || {}).length > 0 && (!isKYCVerified || (!isAMLApproved && isDocRequiredForAml)) && (
        <WarningBar {...getWarningBarProps()} />
      )}
      <SecondaryMarketIdentityUpload
        visible={showIdentityModal}
        onClose={() => setShowIdentityModal(false)}
        onSuccess={() => setShowIdentityModal(false)}
      />
      <div className='container-fluid'>
        <div className='markethero'>
          <div className='markethero__text'>
            <h2>The Realbricks Marketplace</h2>
            <p>
              Explore everything the Realbricks marketplace has to offer. As properties become available, you can choose investments that align with your long-term goals and potentially start building wealth.
            </p>
          </div>
          <div className='markethero__img'>
            <LazyLoadImage src={Images.hero} alt='The Realbricks Marketplace' />
          </div>
        </div>
      </div>
    </>
  );
};

export default MarketHero;
